
import React from 'react';
import { Button } from 'antd';

export const isImg = /^http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/;
export const getChildrenToRender = (item, i) => {
  let tag = item.name.indexOf('title') === 0 ? 'h1' : 'div';
  tag = item.href ? 'a' : tag;
  let children = item.children;
  
  // 改进判断：如果是图片URL字符串，创建img元素
  if (typeof item.children === 'string' && item.children.match(isImg)) {
    children = React.createElement('img', { src: item.children, alt: 'img' });
  }
  // 新增判断：如果是require导入的图片模块，也创建img元素
  else if (item.name === 'image' && typeof item.children === 'string' && !item.children.match(isImg)) {
    children = React.createElement('img', { src: item.children, alt: 'img' });
  }
  
  if (item.name.indexOf('button') === 0 && typeof item.children === 'object') {
    children = React.createElement(Button, {
      ...item.children
    });
  }
  
  return React.createElement(tag, { key: i.toString(), ...item }, children);
};
